import { type PropsWithChildren, Suspense } from 'react';

export const SuspendedWithoutFallback = ({ children }: PropsWithChildren) => (
    <Suspense fallback={<div />}>{children}</Suspense>
);
